import { Component, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { RouterOutlet } from '@angular/router';
import { AuthService } from './core/services/auth.service';
import { SessionStateService } from './core/services/session-state.service';
import { AuthModalComponent } from './features/auth/auth-modal.component';
import { OnboardingService } from './core/services/onboarding.service';
import { UndoService } from './core/services/undo.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, AuthModalComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  private readonly auth = inject(AuthService);
  private readonly router = inject(Router);
  private readonly onboarding = inject(OnboardingService);
  readonly sessionState = inject(SessionStateService);
  readonly undoSvc = inject(UndoService);

  ngOnInit(): void {
    this.auth.checkStatus().subscribe({
      next: res => {
        if (!res.loggedIn || !res.user) {
          this.onboarding.reset();
          return;
        }

        this.onboarding.load().subscribe({
          next: profile => {
            const path = this.router.url.split('?')[0];
            if (!profile.onboardingComplete && path !== '/onboarding') {
              this.router.navigate(['/onboarding']);
            }
          },
          error: () => {
            // Keep app usable if profile fetch fails.
          },
        });
      },
      error: () => {
        this.onboarding.reset();
      },
    });
  }
}
